import { render, staticRenderFns } from "./LocaleForm.vue?vue&type=template&id=8114a7ca&"
import script from "./LocaleForm.vue?vue&type=script&lang=js&"
export * from "./LocaleForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports